import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  computed,
  input,
  model,
  output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ss-checkbox',
  imports: [],
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements ControlValueAccessor {
  checked = model<boolean>(false);
  name = input<any>();
  invalid = input<boolean>(false);
  id = input<string>();
  label = input<string>();
  containerClasses = input<string[]>([]);
  actionState = input<{
    isProcessing?: boolean;
  } | null>();
  /*
    Need to leave the disabled input to handle checkbox cases like casting sign in sheet:
    <ss-checkbox
      [disabled]="true"
      type="checkbox"
      [checked]="true"
      class="pointer-events-none"
    />
  */
  disabled = model<boolean>(false);
  changeValue = output<{ detail: any }>();
  tryClickOnDisabledMode = output();
  isDisabled = computed(() => this.actionState()?.isProcessing);

  onClick() {
    if (this.disabled()) {
      this.tryClickOnDisabledMode.emit();
      return;
    }

    const newCheckedValue = !this.checked();
    this.checked.update((value) => !value);
    this.changeValue.emit({ detail: newCheckedValue });
    this.onChange(newCheckedValue);
    this.onTouched();
  }
  onTouched = () => {};
  onChange = (subscribed: boolean) => {};
  writeValue(value: boolean): void {
    this.checked.set(value);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }
}
